import { render, staticRenderFns } from "./AssignClientDialog.vue?vue&type=template&id=3f958e8c&scoped=true&"
import script from "./AssignClientDialog.vue?vue&type=script&lang=js&"
export * from "./AssignClientDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssignClientDialog.vue?vue&type=style&index=0&id=3f958e8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f958e8c",
  null
  
)

export default component.exports